import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[luiStretchedLink]',
  standalone: true,
})
export class StretchedLinkDirective {
  @HostBinding('class') hostClass = 'lui-stretched-link';
}
